import { useEffect, useState } from "react";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
import SystemModal from "../Common/SystemModal";
import numberToWords from "number-to-words";
const InvoicePrintableStatement = (props) => {
  const Print = (e, controls) => {
    e.preventDefault();
    const printContents = document.getElementById("printablediv").innerHTML;
    const originalTitle = document.title;
    const newWindow = window.open("", "_blank");
    newWindow.document.open();
    newWindow.document.write(`
      <html>
        <head>
          <title>${originalTitle} - Print</title>
        </head>
        <body style="font-family: Arial, sans-serif; margin: 0; padding: .5cm; width: 21cm; height: 29.7cm;">
          ${printContents}
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.onafterprint = () => {
      newWindow.close();
      controls.close();
    };
  };
  const [inv_info, setInvo_ifo] = useState("");
  const [clientinfo, setClientinfo] = useState("");
  const [invo_details, setInvo_details] = useState([]);
  const [invo_statement, setInvoice_statement] = useState([]);
  const get_incoice_details = async () => {
    const data = { InvoID: props.id };
    const server_response = await ajaxAccounting.getInvoice_and_details(data);
    if (server_response.status === "OK") {
      setInvo_ifo(server_response.details.info);
      setInvo_details(server_response.details.details);
      setClientinfo(server_response.details.clientinfo);
    }
  };
  const getInvoiceStatement = async () => {
    const data = { folioID: props.folioID };
    const server_response = await ajaxAccounting.getInvoice_statement(data);
    if (server_response.status === "OK") {
      setInvoice_statement(server_response.details);
    }
  };
  const amountToWords = (amount) => {
    if (!amount) return "";
    const words = numberToWords.toWords(amount);
    return words.charAt(0).toUpperCase() + words.slice(1);
  };
  useEffect(() => {
    get_incoice_details();
    getInvoiceStatement();
  }, []);
  const RenderFooter = (controls) => (
    <>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={controls.close}
      >
        Close
      </button>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={(e) => Print(e, controls)}
      >
        Print
      </button>
    </>
  );
  return (
    <SystemModal
      title="Invoice Printing"
      id="model-new-ledger"
      size="lg"
      footer={RenderFooter}
    >
      <div id="printablediv">
        <div
          style={{
            fontFamily: "Arial, sans-serif",
            backgroundImage: `url(${process.env.PUBLIC_URL}/template/assets/images/doc_back.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100%",
            width: "21cm",
            padding: "1cm",
          }}
        >
          {/* Header Section */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            {/* Company details */}
            <div style={{ width: "80%", lineHeight: "4px" }}>
              <h3 align="center">BERICOT AFRICA LIMITED</h3>
              <p style={{ fontSize: "14px" }} align="center">
                P.O.BOX 28775 KAMPALA
              </p>
              <p style={{ fontSize: "14px" }} align="center">
                PLOT 79B MAKAMBA ROAD
              </p>
              <p style={{ fontSize: "14px" }} align="center">
                TEL :+256701666160
              </p>
              <p style={{ fontSize: "14px" }} align="center">
                EMAIL :info@bericot.africa
              </p>
              <h4 align="center">Invoice: {inv_info.Invo_no}</h4>
            </div>
            {/* Company logo */}
            <div style={{ width: "20%" }}>
              <img
                style={{
                  position: "absolute",
                  height: "100px",
                  width: "100px",
                }}
                src={`${process.env.PUBLIC_URL}/template/assets/images/bricote_logo.png`}
                alt="Logo"
              />
            </div>
          </div>
          {/* Client and project info */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "10px",
              color: "grey",
              width: "100%",
            }}
          >
            <div>
              <h4>
                <b>DR</b>
              </h4>
              <h5 align="left">
                <b>{clientinfo?.name}</b>
              </h5>
              <p style={{ fontSize: "14px" }}>{clientinfo?.p_o_box}</p>
              <p style={{ fontSize: "14px" }}>{clientinfo?.location}</p>
              <p style={{ fontSize: "14px" }}>TEL :+{clientinfo?.contact}</p>
              <p style={{ fontSize: "14px" }}>EMAIL : {clientinfo?.email}</p>
              <p>
                <b>Project_name:</b> {inv_info.project_name}
              </p>
            </div>
            <div>
              <p>Invoice Date : {inv_info.date?.short_date}</p>
              <p>
                Ref No. <span style={{ color: "blue" }}>{inv_info.ref_no}</span>
              </p>
              <p>
                LPO No.:{" "}
                <span style={{ color: "blue" }}>{inv_info.lpo_no}</span>
              </p>
            </div>
          </div>
          {/* Invoice details table */}
          <div style={{ width: "100%", marginTop: "10px" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px groove grey",
                textAlign: "center",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "rgba(51,181,255,0.7)",
                    height: "30px",
                  }}
                >
                  <th>No</th>
                  <th style={{ width: "300px" }}>Details</th>
                  <th>Units</th>
                  <th>Rate</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {invo_details.map((item, key) => (
                  <tr
                    key={key}
                    style={{
                      color: "black",
                      height: "40px",
                      borderBottom: "1px grey solid",
                    }}
                  >
                    <td>{key + 1}</td>
                    <td style={{ width: "300px", wordWrap: "break-word" }}>
                      {item.invoicable_item}
                    </td>
                    <td>{item.unit}</td>
                    <td>{item.rate.rate_c}</td>
                    <td>{item.quantity.quantity_c}</td>
                    <td>{item.amount.amount_c}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Totals Section */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <table
              style={{
                width: "50%",
                borderCollapse: "collapse",
                border: "2px groove grey",
                textAlign: "center",
              }}
            >
              <tbody>
                <tr style={{ color: "black", borderBottom: "1px grey solid" }}>
                  <td style={{ width: "150px" }}>
                    <b>Amount:</b>
                  </td>
                  <td style={{ width: "150px" }}>
                    Ugx {inv_info.amount_crude?.amount_crude_c}
                  </td>
                </tr>
                <tr style={{ color: "black", borderBottom: "1px grey solid" }}>
                  <td>
                    <b>V.A.T(18%):</b>
                  </td>
                  <td>Ugx {inv_info.vat?.vat_c}</td>
                </tr>
                <tr style={{ color: "black", borderBottom: "1px grey solid" }}>
                  <td>
                    <b>Total Amount:</b>
                  </td>
                  <td>Ugx {inv_info.Amount_vated?.Amount_vated_c}</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Amount in Words */}
          <div style={{ marginTop: "10px" }}>
            <p>
              <b>Amount In Words:</b>{" "}
              <span style={{ color: "grey" }}>
                <u>
                  {amountToWords(inv_info.Amount_vated?.Amount_vated)} shillings
                </u>
              </span>
            </p>
          </div>
          {/* ⚡ Payment Statement Table ⚡ */}
          {invo_statement.length > 0 && (
            <div style={{ marginTop: "30px" }}>
              <h4 style={{ textAlign: "center", marginBottom: "10px" }}>
                Payment Statement
              </h4>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid grey",
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "rgba(51,181,255,0.7)",
                      height: "35px",
                      color: "white",
                    }}
                  >
                    <th>#</th>
                    <th>Date</th>
                    <th>Credit (UGX)</th>
                    <th>Debit (UGX)</th>
                    <th>Running Balance (UGX)</th>
                  </tr>
                </thead>
                <tbody>
                  {invo_statement.map((row, idx) => (
                    <tr
                      key={row.id}
                      style={{
                        color: "black",
                        height: "35px",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      <td>{idx + 1}</td>
                      <td>{new Date(row.date).toLocaleDateString()}</td>
                      <td>{Number(row.credit).toFixed(2)}</td>
                      <td>{Number(row.debit).toFixed(2)}</td>
                      <td>{Number(row.balance).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {/* Footer */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              marginTop: "20px",
              color: "grey",
            }}
          >
            <div>
              <p>Authorized By: ________________________</p>
            </div>
            <div>
              <p>Printed on: {new Date().toLocaleDateString()}</p>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default InvoicePrintableStatement;
